import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
/**
 * Exclusion metadata contains all information about table's exclusion constraints.
 */
export var ExclusionMetadata = /*#__PURE__*/function () {
  // ---------------------------------------------------------------------
  // Constructor
  // ---------------------------------------------------------------------
  function ExclusionMetadata(options) {
    _classCallCheck(this, ExclusionMetadata);
    this.entityMetadata = options.entityMetadata;
    if (options.args) {
      this.target = options.args.target;
      this.expression = options.args.expression;
      this.givenName = options.args.name;
    }
  }
  // ---------------------------------------------------------------------
  // Public Build Methods
  // ---------------------------------------------------------------------
  /**
   * Builds some depend exclusion constraint properties.
   * Must be called after all entity metadata's properties map, columns and relations are built.
   */
  _createClass(ExclusionMetadata, [{
    key: "build",
    value: function build(namingStrategy) {
      this.name = this.givenName ? this.givenName : namingStrategy.exclusionConstraintName(this.entityMetadata.tableName, this.expression);
      return this;
    }
  }]);
  return ExclusionMetadata;
}();